/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

// SetTransform.js

import { createTransform } from "redux-persist";

// Custom transform to serialize Date objects
export const dateTransform = createTransform(
  // Transform state on its way to being serialized and persisted
  (inboundState) => {
    const transformedState = JSON.parse(
      JSON.stringify(inboundState, (key, value) => {
        return value instanceof Date ? value.toISOString() : value;
      })
    );
    return transformedState;
  },
  // Transform state being rehydrated
  (outboundState) => {
    const transformedState = JSON.parse(
      JSON.stringify(outboundState, (key, value) => {
        if (typeof value === "string" && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(value)) {
          return new Date(value);
        }
        return value;
      })
    );
    return transformedState;
  }
);

const Transforms = [dateTransform];

export default Transforms;
